<template>
  <span style="display: inline-flex; align-items: center">
    {{ label }}

    <span
      v-if="isRequired"
      style="
        color: var(--n-asterisk-color, #d03050);
        display: inline-block;
        transform: scale(2) translateY(2px);
        margin-left: 4px;
      "
      >*</span
    >

    <n-tooltip v-if="demoTooltipText && isDemoModeEnabled" trigger="hover">
      <template #trigger>
        <n-icon
          size="14"
          style="cursor: pointer; color: #888; margin-left: 6px; display: inline-flex"
          @click="$emit('onDemoClick')"
        >
          <InformationCircleOutline />
        </n-icon>
      </template>
      {{ demoTooltipText }}
    </n-tooltip>
  </span>
</template>

<script lang="ts" setup>
import { InformationCircleOutline } from '@vicons/ionicons5';
import { useDemoMode } from '../composables/useDemoMode';

const { isDemoModeEnabled } = useDemoMode();

defineProps<{
  label: string;
  isRequired?: boolean;
  demoTooltipText?: string;
}>();

defineEmits<{
  (e: 'onDemoClick'): void;
}>();
</script>
